'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ADMIN: 'ADMIN',
  ATTEMPTING_TO_CAST: 'ATTEMPTING_TO_CAST',
  DEVICE_CONNECTED: 'DEVICE_CONNECTED',
  DEVICE_DISCONNECTED: 'DEVICE_DISCONNECTED',
  DEVICE_FAILED: 'DEVICE_FAILED',
  DEVICE_PAIRING_STAGE1: 'DEVICE_PAIRING_STAGE1',
  DEVICE_PAIRING_STAGE2: 'DEVICE_PAIRING_STAGE2',
  DEVICE_SELECTION: 'DEVICE_SELECTION',
  INPUT_INFO_WELCOME: 'INPUT_INFO_WELCOME',
  INPUT_INFO: 'INPUT_INFO',
  INPUT_TAGLINE: 'INPUT_TAGLINE',
  PREPARE_WEARABLE: 'PREPARE_WEARABLE',
  READY_TO_CAST: 'READY_TO_CAST',
  UNINITIALIZED: 'UNINITIALIZED',
  UNSUPPORTED: 'UNSUPPORTED'
};